import React from 'react';
import { observer } from '../../shared/observer';

class LoginButtonView extends React.Component {
  render() {
    const auth = this.props.auth;
    const ci = auth.clientInfo;
    if (auth.isAuthenticated) {
      const name = (ci && (ci.mobile_first_name || ci.mobile_fio || ci.phone || ci.email)) || 'Профиль';
      return (
        <div className="login-button">
          <a href="/profile">{name}</a>
        </div>
      );
    }
    return (
      <div className="login-button">
        <a href="#" onClick={(e) => { e.preventDefault(); auth.setLoginDialogOpen(true); }}>Войти</a>
      </div>
    );
  }
}

export const LoginButton = observer(LoginButtonView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/LoginButton.jsx